import { Box, Text, Spacer, Grid } from "@flexisaf/flexibull2";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import QuizathonEmptyState from "../../components/custom/QuizathonEmptyState";
import UserEmptyState from "../../assets/ImageEmptyState.svg";
import SectionLoader from "../../components/custom/sectionLoader";
import useParticipantLeaderboard from "../../hooks/quizathon/useParticipantLeaderboard";
import BreadCrumbs from "../../components/breadcrumb";


const UserProfile = () => {
  const { quizathonId , studentId } = useParams();
  const { participantLeaderboard, loadingParticipantLeaderboard } =
    useParticipantLeaderboard({ studentId ,  quizathonId});

  return (
    <Container>
      <BreadCrumbs
       links={[{ path: `/quizathon-list/${quizathonId}`, text: "Back" }]}
        last={"Participant"}
      />
      <Spacer space={15} />
      <Text bold size="1.3rem">
        Student Profile
      </Text>
      {loadingParticipantLeaderboard ? (
        <SectionLoader  />
      ) : participantLeaderboard?.length ? (
        participantLeaderboard.map((participant) => (
          <Box key={participant?.participant.id}>
            <Spacer space={15} />
            <Grid
              default="minmax(auto, 400px) minmax(auto, 300px) auto max-content max-content"
              sm="1fr"
              style={{ alignItems: "center" }}
            >
              <img
                src={
                  participant?.participant?.userInfo?.profileImage ||
                  UserEmptyState
                }
                className="image-emptystate"
                alt="Profile"
              />
              <Box />
              <Box />
           
            </Grid>
            <Spacer space={20} />
            <Box className="preview-container">
              <Grid default="1fr 1fr" sm="1fr" gap="1rem">
                <Box>
                  <Text bold>Participant's Name</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {`${participant?.participant?.userInfo?.firstName} ${participant?.participant?.userInfo?.lastName}` ||
                        "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>Email Address</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.userInfo?.email || "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>Phone Number</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.userInfo?.phoneNumber ||
                        "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>Institution</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.schoolInformation?.school?.name ||
                        "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>Department</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.schoolInformation?.department?.name ||
                        "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>Level</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.schoolInformation?.level || "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>State Of Origin</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.userInfo?.stateOfOrigin ||
                        "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>Matriculation Number</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.schoolInformation
                        ?.matriculationNumber || "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>Total Score</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.totalScores || "-- / --"}
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <Text bold>Total Time Spent (minutes)</Text>
                  <Spacer space="5px" />
                  <Box className="label-preview">
                    <Text style={{ color: "#707070" }}>
                      {participant?.participant?.totalTimeSpent || "-- / --"}
                    </Text>
                  </Box>
                </Box>
              </Grid>
              <Spacer space="30px" />
              <Box>
                <Text bold>Courses taken and scores</Text>
                <Spacer space="15px" />
                <Box maxWidth="900px">
                <Grid default="1fr 1fr 1fr" sm="1fr" gap="1rem" >
                  {participant?.results?.length ? (
                    participant?.results.map((result) => (
                      <Box key={result.id} className="result-preview">
                        <Text style={{ color: "#707070" }}>
                          {result?.paper.name}
                        </Text>
                        <Text bold>{result.score}</Text>
                      </Box>
                    ))
                  ) : (
                    <Box>
                      <Spacer space="10px" />
                      <Text bold block>No courses found</Text>
                    </Box>
                  )}
                </Grid>
                </Box>
              </Box>
            </Box>
          </Box>
        ))
      ) : (
        <QuizathonEmptyState title="No Data Found" />
      )}
    </Container>
  );
};

export default UserProfile;

const Container = styled(Box)`
  & .image-emptystate {
    width: 168px;
    height: 168px;
    object-fit: cover;
    border-radius: 8px;
  }
  & .preview-container {
    background-color: #ffff;
    padding: 1rem;
    margin-bottom: 3rem;
  }
  & .label-preview {
    background-color: #f7f9fa;
    padding: 0.9rem;
  }
  & .result-preview {
    background-color: #f7f9fa;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.9rem;
  }
`;
